import modules from './settings/index'

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, modules
}
